import { render, staticRenderFns } from "./toggle-v3.vue?vue&type=template&id=8d91c9b8"
import script from "./toggle-v3.js?vue&type=script&lang=js&external"
export * from "./toggle-v3.js?vue&type=script&lang=js&external"
import style0 from "./toggle-v3.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports